import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    submitFeedback: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label shown in the Premiere extension that opens a feedback/report flow for the new extension */
            submitFeedback: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PremiereIntegrationNavItems.submitFeedback?c=5adg65suwfs8", defaultMessage: "Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
